import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalInput,
} from "component/common";
import { withTranslation } from "react-i18next";
import {
  NewApptSecondaryStatuses,
  ApptSecondaryStatuses,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";

export default class SecondarystatuslistClass extends Component {
  state = {
    code: null,
    desc: null,
    colorcode: null,
    staffList: [],
    checked: true,
  };

  componentDidMount = () => {
    this.Listofsstate({});
  };

  Listofsstate = async () => {
    let { List, code } = this.state;
    await this.props.ApptSecondaryStatuses().then((res) => {
      console.log(res);
      List = res;
      console.log(List);
      this.setState({
        List,
      });
    });
    if (List.length > 0) {
      code = List[List.length - 1].ssCode;
      code = Number(code) + 1;
    } else {
      code = 10001;
    }
    this.setState({
      code,
    });
  };

  temp = ({ target: { value, name } }) => {
    console.log(value, name);
    let { code, desc, colorcode, checked } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "colorcode") {
      colorcode = value;
      this.setState({ colorcode });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
  };

  Addnewstate = async () => {
    let { code, desc, colorcode, checked } = this.state;
    if (code == null || desc == null) {
      Toast({
        type: "error",
        message: "Description required",
      });
    } else {
      let newbooking = {
        ssCode: code,
        ssDesc: desc,
        ssColorCode: colorcode,
        active: true,
      };
      await this.props
        .NewApptSecondaryStatuses(newbooking)
        .then((data) => {
          code = "";
          desc = "";
          colorcode = "";
          checked = false;
          this.setState({ checked, code, desc, colorcode });
          Toast({
            type: "success",
            message: "Added Successfully",
          });
          this.props.history.push("/admin/backend/appointment/secondary")
          this.Listofsstate();
        })
        .catch((e) => console.log(e));
    }
  };

  render() {
    let { t } = this.props;
    let { code, desc, colorcode, checked } = this.state;
    return (
      <div className="bg-white">
        <div className="row col-12">
          <div className="col-12 d-md-flex align-items-center mt-3">
            <div className="detail d-flex">
              <h6
                className="category"
                onClick={() => this.props.history.push("/admin/backend")}
              >
                {t("Master Data")}
              </h6>
              <i className="icon-right mx-md-3 p-1"></i>
              <h6
                className="sub-category"
                onClick={() => this.props.history.push("/admin/backend")}
              >
                {t("Appointment config")}
              </h6>
              <i className="icon-right mx-md-3 p-1"></i>
              <h6
                className="sub-category"
                onClick={() => this.props.history.push("/admin/backend")}
              >
                {t("Secondary Status List ")}
              </h6>
              <i className="icon-right mx-md-3 p-1"></i>
              <h6 className="sub-category">{t("Operation")}</h6>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h5 className="mt-3 mb-0 label-head text-center text-md-left">
                Appointment Secondary Status{" "}
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="mt-3">
                <span>{t("Code")}</span>
                <span style={{ color: "red" }}>*</span>
                <div className="input-group">
                  <NormalInput
                    value={code}
                    name="code"
                    onChange={this.temp}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="mt-3">
                <p>{t("Color Code")}</p>
                <div className="input-group">
                  <NormalInput value={colorcode} onChange={this.temp} />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="mt-3">
                <span>{t("Description")}</span>
                <span style={{ color: "red" }}>*</span>
                <div className="input-group">
                  <NormalInput value={desc} name="desc" onChange={this.temp} />
                </div>
              </div>
              <div className="mt-3">
                <div className="mt-3 p-1"> </div>
                <input
                  type="color"
                  className="mt-3"
                  style={{ width: 70 }}
                  onChange={this.temp}
                  name="colorcode"
                />
              </div>
            </div>
          </div>
          <div className="mt-3">
            <div className="d-flex input-group">
              <NormalCheckbox
                checked={checked}
                name="checked"
                onChange={this.temp}
              />
              <p>{t("is Currently Active")}</p>
            </div>
          </div>
          <div className="mt-3mt-3 col-12 m-0 p-0 d-flex justify-content-center justify-content-md-start">
            <div className="col-6 p-0 col-md-2">
              <NormalButtonBackend
                mainbg={true}
                label={"Add"}
                onClick={() => this.Addnewstate()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      NewApptSecondaryStatuses,
      ApptSecondaryStatuses,
    },
    dispatch
  );
};

export const Secondarystatuslist = withTranslation()(
  connect(null, mapDispatchToProps)(SecondarystatuslistClass)
);
